import axios from "axios";

export default {
    data() {
        return {
            importSpreadsheetsListNextParam: null,
            exportSpreadsheetsListNextParam: null,
            importSpreadsheetsList: [],
            exportSpreadsheetsList: [],
            isLoadingMoreSpreadsheets: false,
        }
    },
    computed: {
        currentSpreadsheetTab() {
            let obj = null;

            if (this.tab === 'imports' || this.tab === 'exports') {
                obj = { list: null, nextParam: null };

                if (this.tab === 'imports') {
                    obj.list = this.importSpreadsheetsList;
                    obj.nextParam = this.importSpreadsheetsListNextParam;
                } else if (this.tab === 'exports') {
                    obj.list = this.exportSpreadsheetsList;
                    obj.nextParam = this.exportSpreadsheetsListNextParam;
                }
            }

            return obj;
        },
    },
    methods: {

        requestSpreadsheets(type, next = null) {
            this.isLoading = true;

            let nextParam = '';

            if (next !== null) {
                nextParam = `?next=${next}`;
            }

            return axios
                .get(`/api/orders/${type}${nextParam}`)
                .then((response) => {
                    const listName = type === 'imports' ? 'importSpreadsheetsList' : 'exportSpreadsheetsList';

                    this[listName] = [...this[listName], ...response.data.spreadsheets] || [];

                    let lastItem = null;

                    if (response.data.spreadsheets.length > 0) {
                        lastItem = this[listName][this[listName].length - 1];
                        this[`${listName}NextParam`] = lastItem.id;
                    } else {
                        this[`${listName}NextParam`] = null;
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        loadMoreSpreadsheets() {
            if (this.currentSpreadsheetTab.nextParam !== null) {
                this.isLoadingMoreSpreadsheets = true;

                this.requestSpreadsheets(this.tab === 'imports' ? 'import' : 'export', this.currentSpreadsheetTab.nextParam)
                    .finally(() => {
                        this.isLoadingMoreSpreadsheets = false;
                    });
            }
        }

    },

};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/spreedsheets.js